<template>
    <div class="badge-container">
        <div v-if="assign.passTypeId === $parent.getPassTypeId('Universal')" class="badge-list">
            <div v-if="assign.id !== null" class="badge badge-control">Контроль</div>
            <div class="badge badge-selfstudy">Самообучение</div>
        </div>
        <div v-else class="badge-list">
            <div class="badge" :class="{
                    'badge-control': assign.passTypeId === $parent.getPassTypeId('Control'),
                    'badge-selfstudy': assign.passTypeId === $parent.getPassTypeId('SelfStudy')
                }">
                {{ assign.passTypeName }}
            </div>
        </div>
    </div>
</template>

<script>
import './PassTypeBadge.scss';

export default {
    name: 'PassTypeBadge',
    props: {
        assign: Object
    }
}
</script>
